import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import OfferCard from "../cards/OfferCard.tsx";
import {ComponentRef, useEffect, useRef, useState} from "react";
import { useIntersectionObserver } from "usehooks-ts";
import { useSuspenseInfiniteQuery } from "@tanstack/react-query";
import { useTaskCollectionListOptions } from "@/pages/get-don/tasks.api.ts";
import BaseButton from "@/components/base/button/BaseButton.tsx";
import IconCircle from "/src/assets/icons/info-circle.svg?react";
import WeeklyModal from "@/components/weekly-modal/WeeklyModal.tsx";

export default function SpecialOfferSlider() {
  const {t} = useTranslation();

  const rootEl = useRef<ComponentRef<"div">>(null);
  const {isIntersecting, ref} = useIntersectionObserver({
    threshold: 0,
    root: rootEl.current
  });

  const {
    data: tasks,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useSuspenseInfiniteQuery(useTaskCollectionListOptions({weekly:true}));

  // Fetch next page when the loader element is visible
  useEffect(() => {
    if (isIntersecting && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [isIntersecting, hasNextPage, isFetchingNextPage, fetchNextPage]);

  const taskList = tasks.pages.flatMap((page) => page.results);

  // State for modal visibility
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (taskList?.length) {
    return (
    <div className="overflow-hidden -mx-4 px-4">
      <div className="flex justify-between mb-3 items-center">
        <h2 className="text-lg text-white font-bold leading-130 ">{t("weekly_tasks")}</h2>
        <BaseButton
            text={t("ends-in-one-week")}
            suffix={<IconCircle strokeWidth="2" className="w-4 h-4" />}
            className="rounded-full flex items-center gap-1 !py-1.5"
            variant="secondary"
            onClick={() => setIsModalOpen(true)} // Added onClick to open modal
        />
      </div>
      <Swiper spaceBetween={12} className="!overflow-visible">
        {taskList.map((task) => (
            <SwiperSlide className="!w-[97%]" key={task.id}>
              <OfferCard
                  id={task.id}
                  title={task.name}
                  award={task.award}
                  completedTasksCount={task.completed_tasks_count}
                  taskCount={task.tasks_count}
                  bannerSrc={task.banner?.url}
                  totalAward={task.total_award}
                  mode="dark"
              />
            </SwiperSlide>
        ))}
        {(hasNextPage || isFetchingNextPage) && (
            <SwiperSlide className="!w-[97%]">
              <div ref={ref} className="m-0 flex items-center gap-2 relative group rounded-xl">
                <div className="bg-white/08 h-[119px] w-full skeleton flex-center shrink-0 rounded-xl">
                </div>
              </div>
            </SwiperSlide>
        )}
      </Swiper>
      <WeeklyModal  onClose={() => setIsModalOpen(false)} isOpen={isModalOpen}/>
    </div>)
  } else {
    return <></>;
  }
}